import React, { FC, useEffect, useState } from 'react';
import { BlobProvider, PDFDownloadLink } from '@react-pdf/renderer';
import StrengthsDemoPdf from './StrengthsDemoPdf';
import { MainButton } from '../../../atoms';
import GamePdf from './GamePdf';
import { useTranslation } from 'react-i18next';

interface IPdfIndex {
    recievedStatistics?: any;
    selectedStrengthsDemo?: any;
    pdfType: string | undefined;
    teamNumber?: number | undefined;
    threeActions?: { first: string, second: string, third: string }
    isDownloadButton?: boolean;

    setPdfForEmail?(pdfBloob: Blob): void;
    sendEmailWithPdf?(): void;
    setIsStatisticsAlreadyDownloaded?(isStatisticsAlreadyDownloaded: boolean): void;
    sendEmailForDemoSlot?(): void;
}

export const PdfIndexMemo: FC<IPdfIndex> = ({ recievedStatistics, selectedStrengthsDemo, pdfType, teamNumber, threeActions, isDownloadButton, setPdfForEmail, sendEmailWithPdf, setIsStatisticsAlreadyDownloaded, sendEmailForDemoSlot }) => {
    const [isClient, setIsClient] = useState(false);

    const { t } = useTranslation();

    const buttonText = isDownloadButton ? t("downloadDiplomaText") : t("nextText");

    useEffect(() => {
        setIsClient(true)
    }, []);

    const updateTheStatisticsPDF = (blob: Blob) => {
        if (!blob) return;

        if (setPdfForEmail)
            setPdfForEmail(blob);
    };

    const handleDownloadClick = () => {
        if (sendEmailWithPdf && setIsStatisticsAlreadyDownloaded) {
            setIsStatisticsAlreadyDownloaded(true);
            sendEmailWithPdf();
        }
    }

    const handleDownloadStrenghtsDemoClick = () => {
        if (sendEmailForDemoSlot ) {
            sendEmailForDemoSlot();
        }
    }

    if (pdfType === "statistics")
        return (
            <div style={{ zIndex: 10 }}>
                {isClient && (
                    <div style={{ zIndex: 10 }}>
                        <div>
                            <PDFDownloadLink document={<GamePdf recievedStatistics={recievedStatistics} teamNumber={teamNumber} threeActions={threeActions} />} fileName="statistics.pdf">
                                {({ loading }) => (
                                    loading
                                        ?
                                        t("loadingDocumentText")
                                        :
                                        <div style={{ width: "20vw", padding: "20px 0", marginBottom: "100px" }}>
                                            <MainButton type="big" text={buttonText} clickHandler={handleDownloadClick!} />
                                        </div>
                                )}
                            </PDFDownloadLink>
                            <BlobProvider document={<GamePdf recievedStatistics={recievedStatistics} teamNumber={teamNumber} threeActions={threeActions} />}>
                                {({blob}) => {
                                    if(blob)
                                        updateTheStatisticsPDF(blob);
                                        
                                    return null;
                                }}
                            </BlobProvider>
                        </div>
                    </div>
                )}
            </div>
        );

    if (pdfType === "strengthsDemo")
        return (
            <div style={{ zIndex: 10 }}>
                {isClient && (
                    <div>
                        <PDFDownloadLink document={<StrengthsDemoPdf selectedStrengthsDemo={selectedStrengthsDemo} />} fileName="yourStrengths.pdf">
                            {({ loading }) => (
                                loading
                                    ?
                                    t("loadingDocumentText")
                                    :
                                    <div style={{ width: "15vw", padding: "20px 0" }}>
                                        <MainButton type="big" text={t("downloadYourStrengths")} clickHandler={handleDownloadStrenghtsDemoClick} />
                                    </div>
                            )}
                        </PDFDownloadLink>
                    </div>
                )}
            </div>
        );

    return (<div></div>)
}

const PdfIndex = React.memo(PdfIndexMemo);

export default PdfIndex;